<script lang="ts" setup>
defineSlots<{
  default?: () => unknown;
}>();
</script>

<template>
  <div :class="$style.root" data-ui-component="UiTableContextPanelItem">
    <slot />
  </div>
</template>

<style lang="scss" module>
.root {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 6px;
  box-sizing: border-box;
  flex: none;
}
</style>
